import { useEffect, useRef, useState } from "react";

// Header tabella agganciato alla finestra (stile GestioneEcommerce):
// misura l'altezza della barra filtri e rileva quando questa diventa sticky.
export default function useStickyTableHeader() {
  const filtersWrapperRef = useRef(null);
  const stickySentinelRef = useRef(null);
  const [filtersHeight, setFiltersHeight] = useState(0);
  const [isSticky, setIsSticky] = useState(false);

  // Tiene aggiornata l'altezza della barra filtri: l'header sticky si ancora a questa quota.
  useEffect(() => {
    const el = filtersWrapperRef.current;
    if (!el || typeof ResizeObserver === "undefined") return undefined;
    const update = () => setFiltersHeight(el.offsetHeight);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  // Sentinella invisibile: quando esce dalla viewport la barra filtri è in stato sticky.
  useEffect(() => {
    const el = stickySentinelRef.current;
    if (!el || typeof IntersectionObserver === "undefined") return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => setIsSticky(!entry.isIntersecting),
      { threshold: 0, rootMargin: "-10px 0px 0px 0px" }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return { filtersWrapperRef, stickySentinelRef, filtersHeight, isSticky };
}
 